import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-detail-toolbar" }
const _hoisted_2 = { class: "references-detail-toolbar-button-group q-gutter-sm" }
const _hoisted_3 = { class: "ellipsis references-detail-heading iodine-padding-md iodine-sub-headline-large" }

export interface Props{
    titleDescription?: string,
    enableBackButton?: boolean,
    enableNextButton?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesDetailToolbar',
  props: {
    titleDescription: { default: '' },
    enableBackButton: { type: Boolean, default: false },
    enableNextButton: { type: Boolean, default: false }
  },
  emits: ["back-button-clicked", "next-button-clicked"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const onBackButtonClicked = () => {
    emit('back-button-clicked')
};

const onNextButtonClicked = () => {
    emit('next-button-clicked')
};


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_btn, {
        class: "text-none iodine-button-outline",
        dense: "",
        round: "",
        unelevated: "",
        flat: "",
        size: "xs",
        icon: "fa-solid fa-arrow-left",
        disable: !props.enableBackButton,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked()))
      }, null, 8, ["disable"]),
      _createVNode(_component_q_btn, {
        class: "text-none iodine-button-outline",
        dense: "",
        round: "",
        unelevated: "",
        flat: "",
        size: "xs",
        icon: "fa-solid fa-arrow-right",
        disable: !props.enableNextButton,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked()))
      }, null, 8, ["disable"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.titleDescription), 1)
  ]))
}
}

})